interface CheckoutPreviewProps {
  discountPercentage: string;
}

export function CheckoutPreview({ discountPercentage }: CheckoutPreviewProps) {
  // Fixed product price
  const productPrice = 785.95;
  const subtotal = productPrice;

  // Calculate discount
  const discountPercent = parseFloat(discountPercentage) || 0;
  const discountAmount = (subtotal * discountPercent) / 100;
  const total = subtotal - discountAmount;

  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // Generate discount code
  const discountCode = `SAVE${Math.round(discountPercent)}`;

  return (
    <div className="bg-[#F9F9F9] rounded-lg p-4 w-full max-w-lg">
      {/* Product Listings */}
      <div className="mb-4">
        {/* Product */}
        <div className="flex gap-3">
          <div className="relative flex-shrink-0">
            <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-blue-200 to-blue-400 relative overflow-hidden">
              {/* Placeholder for snowboard image */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-full h-full bg-gradient-to-br from-blue-300 to-pink-300 rounded-lg"></div>
              </div>
            </div>
            <div className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs font-semibold rounded flex items-center justify-center">
              1
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">
              The Compare at Price Snowboard
            </p>
            <p className="text-sm font-semibold text-foreground mt-1">
              {formatCurrency(productPrice)}
            </p>
          </div>
        </div>
      </div>

      {/* Discount/Gift Card Section */}
      <div className="mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            value={discountCode}
            readOnly
            className="flex-1 px-3 py-2 border border-border rounded-lg text-sm text-muted-foreground focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            placeholder="Discount code or gift card"
          />
          <button
            type="button"
            className="px-4 py-2 bg-green-200 text-muted-foreground rounded-lg text-sm font-medium hover:bg-gray-300 transition-colors"
          >
            Applied
          </button>
        </div>
      </div>

      {/* Order Summary */}
      <div className="space-y-2 pt-3 border-t border-border">
        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Subtotal · 1 item</span>
          <span className="font-medium text-foreground">
            {formatCurrency(subtotal)}
          </span>
        </div>

        {discountAmount > 0 && (
          <div className="flex justify-between items-center text-sm bg-green-50 px-3 py-2 rounded-lg border border-green-200">
            <span className="text-muted-foreground font-semibold">
              Discount ({discountPercent}%)
            </span>
            <span className="font-bold text-green-600 text-base">
              -{formatCurrency(discountAmount)}
            </span>
          </div>
        )}

        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Shipping</span>
          <span className="text-muted-foreground">Enter shipping address</span>
        </div>

        <div className="flex justify-between items-center pt-2 border-t border-border">
          <span className="font-semibold text-foreground">Total</span>
          <div className="text-right">
            <span className="text-xs text-muted-foreground block">USD</span>
            <span className="text-lg font-bold text-foreground">
              {formatCurrency(total)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
